var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"org-wrapper"},[_c('section',{staticClass:"org-list-wrapper"},[_c('org-list-edit')],1),_vm._v(" "),_c('section',{staticClass:"user-list-wrapper"},[_c('user-list-editor',{staticStyle:{"padding-top":"2em"},attrs:{"org-site-devices":_vm.orgSiteDevices}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c12c06e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/09System-Settings/02Org/index.vue
// module id = null
// module chunks = 